// Keep this in line with backend AuditCategory.cs
export const AuditCategory = {
  Audit: 1,
};
